import { Decimal } from '@snap-types/types/decimal';

type Inputs = {
  resourceLeadTimeWeeks: Decimal | null;
  materialLeadTimeDays: number | null;
};

type Config = {
  planningDaysPerWeek: number;
};

/**
 * The weeks a part waits before its first operation can start, taken from the
 * part's first resource and first material.
 *
 * @note The two are *not* added together — whichever is longer sets the floor,
 * because the resource and the material are waited on in parallel.
 *
 * The two arrive on different units and are compared as weeks rather than as
 * days. The resource lead time is already weeks, straight from `user_1` on the
 * shop resource, so converting it to days and back would only truncate it. The
 * material lead time is Visual's planning lead time in days, and the week it is
 * recorded on is the site's `planningDaysPerWeek`, not the working week the
 * floor runs.
 */
export function baseLeadTimeCalculation(
  { resourceLeadTimeWeeks, materialLeadTimeDays }: Inputs,
  { planningDaysPerWeek }: Config,
): Decimal | null {
  const materialLeadTimeWeeks =
    materialLeadTimeDays === null
      ? null
      : new Decimal(materialLeadTimeDays).dividedBy(planningDaysPerWeek);

  if (resourceLeadTimeWeeks === null) {
    return materialLeadTimeWeeks;
  }

  if (materialLeadTimeWeeks === null) {
    return resourceLeadTimeWeeks;
  }

  return Decimal.max(resourceLeadTimeWeeks, materialLeadTimeWeeks);
}
